// extracted by mini-css-extract-plugin
export default {"docViewerContainer":"CustomDocViewer_docViewerContainer__eNgZe","docViewerActions":"CustomDocViewer_docViewerActions__XOFUb","filename":"CustomDocViewer_filename__m4tpO"};